import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";

export default GrComponentFactory.createClass({
  displayName: "InterviewNewsfeedItemBody",

  propTypes: {
    resource: GrPropTypes.interviewNewsfeedResource(),
  },

  renderImage(resource) {
    if (resource.imageUrl) {
      return (
        <img src={resource.imageUrl} alt={resource.title} />
      );
    } else if (resource.authorImageUrl &&
        resource.bookImageUrl) {
      return (
        <div>
          <a href={resource.resourceUrl}>
            <div className="editorialCard__image--interview
                            editorialCard__image--interviewAuthor"
              style={{ backgroundImage: `url(${resource.authorImageUrl})` }}>
              <span className="u-visuallyHidden">
                {resource.author}
              </span>
            </div>
            <div className="editorialCard__image--interview
                            editorialCard__image--interviewBook"
              style={{ backgroundImage: `url(${resource.bookImageUrl})` }}>
              <span className="u-visuallyHidden">
                {resource.bookTitle}
              </span>
            </div>
          </a>
        </div>
      );
    } else {
      return null;
    }
  },

  bodyHtml() {
    return { __html: this.props.resource.body.html };
  },

  render() {
    const { resource } = this.props;
    return (
      <div className="editorialCard">
        {this.renderImage(resource)}
        <div className="editorialCard__title">
          <a href={resource.resourceUrl}
            className="gr-hyperlink gr-hyperlink--bold">
            {resource.title}
          </a>
        </div>
        <div className="editorialCard__body"
          dangerouslySetInnerHTML={this.bodyHtml()} />
      </div>
    );
  },
});
